<template>
  <v-container fluid class="settings-container">
    <v-overlay :value="isLoadingOverlay" class="loading-overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Navigation />
    <v-content class="content" app>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Navigation from './Navigation/Navigation';

export default {
  data: () => ({
    loading: false
  }),
  computed: mapGetters(['isLoadingOverlay']),
  components: { Navigation }
}
</script>

<style>
.settings-container {
  margin-top: 84px;
  font-family: 'Montserrat'
}

.settings-container .navigation {
  padding-top: 84px;
}

.settings-container .content {
  margin-left: 256px;
}

.loading-overlay {
  z-index: 999999999 !important;
}
</style>
